<template>
    <v-dialog max-width="600" :value="value" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="text-h5 mb-3"
            >
                Istruzioni
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.native="$emit('input', false)">
                        <v-icon color="info">mdi-close</v-icon>
                    </v-btn>
                    </template>
                    <span>Esci</span>
                </v-tooltip>                
            </v-card-title>
            <v-divider></v-divider>
            
            <v-card-text v-if="helpLevel==1" class="text-h6">
            Se disponete di un sito, inserite l'indirizzo
            </v-card-text>
            
            <v-card-text v-if="helpLevel==2" class="text-h6">
            Inserite il Vostro recapito Telefonico
            </v-card-text>				  
            
            <v-card-text v-if="helpLevel==3" class="text-h6">
                <p>
                    l'accesso all'App avviene mediante questi due parametri.
                    <br>E' visualizzata la PEC ma potete inserire qualsiasi indirizzo email.
                    <br>Nota: In caso di smarrimento della Password, il token per il reset verrà inviato a questo indirizzo email.
                </p>
                <p>
                    Per la password è richiesto sia almeno di 8 caratteri, contenga almeno 1 lettera maiuscola ed 1 minuscola, almeno 1 numero ed almeno uno dei seguenti caratteri: @ $ ! % * ? &
                    <br><br>Si consiglia comunque una lunghezza di almeno 10 caratteri
                </p>
            </v-card-text>				  
            
            <v-card-text v-if="helpLevel==4" class="text-h6">
            L' <span class="font-weight-black px-1">Insegna</span> è il testo che apparirà in alto a sinistra sull'App, (come potete vedere inserendo un valore nel campo), o nei messaggi WhatsApp prima che vengano caricate delle immagini con il vostro Logo
            <br>Il testo è libero, ma si consiglia di non superare i 10 Caratteri per evitare problemi di allineamento nella visualizzazione su cellulari
            </v-card-text>


            <v-card-text v-if="helpLevel==5" class="text-h6">
                <p>
                L'<span class="font-weight-black pr-1">URI</span> composto da un sottodominio (propriamente dominio di III livello) e .ibookrestaurant.com, è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni.
                </p>
                <p>
                    Si consiglia di utilizzare l'insegna (o brand) del vostro locale, ma essendo necessario che questo valore sia <span class="font-weight-black">univoco</span> 
                    potrebbe accadere che il nome che volete utilizzare sia già utilizzato: sceglietene un'altro simile
                </p>
                <p>Nota: premesso quanto al punto precedente, la scelta del sottodominio è, in via di principio, a disrezione dell'operatore. 
                Ci riserviamo comunque la facoltà di rifiutare, cancellare, riassegnare dei sottodomini che ritenessimo inadatti o utilizzati in modalità non conforme alla politica aziendale</p>
                            
                <p>La lunghezza del sottodominio deve essere di almeno <span class="font-weight-black px-1">5</span> caratteri.</p>
            </v-card-text>
            
            <v-card-text  v-if="helpLevel==6" class="text-h6">
                <v-row class="mx-5">
                    <v-col md="12" cols="12">
                        <p>
                            l'Hostname è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni ma anche il punto di ingresso all'App:
                        <br />
                            come default utilizza il nome del vostro sito (o il nome del vostro locale) che avete indicato in fase di registrazione: qualora non sia stato fornito utilizza una stringa casuale (che può comunque essere modificata<sup>1</sup> da questa pagina):
                        </p>
                        <p>
                            Ipotizziamo ad esempio, che il vostro locale si chiami <strong>Arcadia</strong> e/o il vostro sito sia <strong>www.arcadia.it</strong>, il sistema vi attribuirà di default il seguente hostname: <strong>arcadia.ibookrestaurant.com</strong>
                        </p>
                        <p>
                            E' disponibile, a fronte di un contributo di configurazione una tantum di 100 €, una soluzione del tipo <strong>booking.arcadia.it</strong> (o <strong>qualsiasicosa.arcadia.it</strong>)
                        </p>
                        <p>In quest caso è necessario che:
                            <ul>
                            <li>
                                Creiate un nuovo hostname e lo denominiate come meglio credete, nell'esempio <strong>booking.arcadia.it</strong>
                            </li>
                            <li>
                                Se non avete già un sito, lo registriamo noi a Vostro nome<sup>2</sup>
                                Se invece avete già un sito, inseriate il recapito di colui che gestisce il nome a dominio <strong>arcadia.it</strong> che contatteremo per le necessarie modifiche.
                                <br />In pratica gli chiederemo di creare il sottodominio <strong>booking</strong> e farlo puntare all'indirizzo <strong>84.247.8.202</strong>.
                                <br />(Più tecnicamente creare il seguente DNS Record: <strong>booking 60 IN A 84.247.8.202</strong>)
                            </li>  
                            </ul>
                        <p>
                            Non appena le impostazioni si saranno propagate (il tempo canonico è 24 ore) provvederemo ad apportare le necessarie modifiche di configurazione e l'indirizzo sarà attivo
                        </p>
                        <p>
                            <sup>1</sup>Se non è già utilizzato
                            <sup>2</sup>(dall'anno successivo vi verrà addebitato un canone di 30.00€)
                            </p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card> 
    </v-dialog>   
</template>
<script>
export default {
    props:['value','helpLevel'],
    data () {
    return {
      dialog:false,
    }},
}
</script>